// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import GeneralActionTypes from './general.types';
import {
	getAllCountriesList,
	getAllStateList,
	getAllCityList,
	getAllPincodeList,
	getDistrictList,
	getAllIndustryList,
	getSubIndustryList,
	allBranchesFetch,
	allPurposeOfLoanListFetch,
	allPurposeOfLoanTypeFetch,
	allBusinessDetailsFetch,
	allProductTypeFetch,
	allProductsFetch,
	allBranchOfficerFetch,
	allCenterFetch,
	allInvestorFetch,
	fetchallGroup,
	fetchGroupCenterFetch,
	fetchGroupMembersFetch,
	BranchAccountListFetch,
	fetchGroupLoanIndexListAPI,
	fetchSearchLoanIndexListAPI,
	VersionDetailsFetch,
	VersionDetailsUpdate,
	PincodeDetailsFetch,
	getAllLocationListBasedLevel,
	checkAuthenticationKeyAPI,
	getAllPurposeOfLoanProposalList,
	getAllOfficerBesedOnLevelListProposal,
	getAllThriftListProposal,
	getAllThriftDetails,
	getAllNonApproveMembersDetails,
	todayGoldPriceGet,
	todayGoldPriceUpdate,
	StatewiseBranchDetails,
} from './general.service';
import {
	getCountryListSuccess,
	getCountryListFailure,
	getCountryListResponseChanged,
	getStateListSuccess,
	getStateListFailure,
	getStateListResponseChanged,
	getCityListSuccess,
	getCityListFailure,
	getCityListResponseChanged,
	getDistrictListSuccess,
	getDistrictListFailure,
	getDistrictListResponseChanged,
	getAllIndustryListSuccess,
	getAllIndustryListFailure,
	getAllIndustryListResponseChanged,
	getSubIndustryListSuccess,
	getSubIndustryListFailure,
	getSubIndustryListResponseChanged,
	fetchAllBranchesSuccess,
	fetchAllBranchesFailure,
	fetchAllBranchesResponseChanged,
	fetchAllPurposeOfLoanListSuccess,
	fetchAllPurposeOfLoanListFailure,
	fetchAllPurposeOfLoanListResponseChanged,
	fetchAllPurposeOfLoanTypeSuccess,
	fetchAllPurposeOfLoanTypeFailure,
	fetchAllPurposeOfLoanTypeResponseChanged,
	fetchAllBusinessListSuccess,
	fetchAllBusinessListFailure,
	fetchAllBusinessListResponseChanged,
	fetchAllProductTypeSuccess,
	fetchAllProductTypeFailure,
	fetchAllProductTypeResponseChanged,
	fetchAllProductListSuccess,
	fetchAllProductListFailure,
	fetchAllProductListResponseChanged,
	fetchAllBranchOfficerSuccess,
	fetchAllBranchOfficerFailure,
	fetchAllBranchOfficerResponseChanged,
	fetchAllCenterListSuccess,
	fetchAllCenterListFailure,
	fetchAllCenterListResponseChanged,
	fetchCenterGroupListSuccess,
	fetchCenterGroupListFailure,
	fetchCenterGroupListResponseChanged,
	fetchGroupMemberListSuccess,
	fetchGroupMemberListFailure,
	fetchGroupMemberListResponseChanged,
	fetchAllInverstorListSuccess,
	fetchAllInverstorListFailure,
	fetchAllInverstorListResponseChanged,
	fetchAllGroupListFailure,
	fetchAllGroupListSuccess,
	fetchAllGroupListResponseChanged,
	getPinCodeListFailure,
	getPinCodeListSuccess,
	getPinCodeListResponseChanged,
	fetchBranchAccountListSuccess,
	fetchBranchAccountListFailure,
	fetchBranchAccountListResponseChanged,
	fetchGroupLoanIndexSuccess,
	fetchGroupLoanIndexFailure,
	fetchGroupLoanIndexResponseChanged,
	fetchSearchLoanIndexSuccess,
	fetchSearchLoanIndexFailure,
	fetchSearchLoanIndexResponseChanged,
	fetchVersionSuccess,
	fetchVersionFailure,
	fetchVersionResponseChanged,
	updateVersionSuccess,
	updateVersionFailure,
	updateVersionResponseChanged,
	fetchPincodeDetailsSuccess,
	fetchPincodeDetailsFailure,
	fetchPincodeDetailsResponseChanged,
	genericPincodeDetailsSuccess,
	genericPincodeDetailsFailure,
	genericPincodeDetailsResponseChanged,
	getLocationListBasedLevelSuccess,
	getLocationListBasedLevelFailure,
	getLocationListBasedLevelResponseChanged,
	checkGoogleAuthenticationSuccess,
	checkGoogleAuthenticationFailure,
	checkGoogleAuthenticationResponseChanged,
	getPurposeOfLoanProposalListSuccess,
	getPurposeOfLoanProposalListFailure,
	getPurposeOfLoanProposalListResponseChanged,
	getOfficerBesedOnLevelListProposalSuccess,
	getOfficerBesedOnLevelListProposalFailure,
	getOfficerBesedOnLevelListProposalResponseChanged,
	getThriftListProposalSuccess,
	getThriftListProposalFailure,
	getThriftListProposalResponseChanged,
	getThriftDetailsSuccess,
	getThriftDetailsFailure,
	getThriftDetailsResponseChanged,
	getNonApproveMembersDetailsSuccess,
	getNonApproveMembersDetailsFailure,
	getNonApproveMembersDetailsResponseChanged,
	getTodayGoldPriceSuccess,
	getTodayGoldPriceFailure,
	getTodayGoldPriceResponseChanged,
	updateTodayGoldPriceSuccess,
	updateTodayGoldPriceFailure,
	updateTodayGoldPriceResponseChanged,
	GetStatewiseBranchesResponceChanged,
	GetStatewiseBranchesFailure,
	GetStatewiseBranchesSuccess,
	getThriftTwoDetailsSuccess,
	getThriftTwoDetailsResponseChanged,
	getThriftTwoDetailsFailure,
} from './general.action';
import { encryptData } from '../_common/enode-decode';

import AlertManager from '../../utils/alertManager';
/** *********************  START COUNTRY LIST  ******************** */
export function* getCountryList() {
	try {
		const jsonData = {
			CountryID: '',
		};
		const countryData = encryptData(jsonData, 'GetCountryListKey');
		// @ts-ignore
		const responseData = yield call(getAllCountriesList, countryData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getCountryListFailure(responseData.data));
		} else {
			yield put(getCountryListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCountryListFailure(error));
	}
}

export function* resetCountryList() {
	yield put(getCountryListResponseChanged());
}

export function* onGetCountryList() {
	yield takeLatest(GeneralActionTypes.GET_COUNTRY_LIST_START, getCountryList);
}

export function* onResetCountryResponseStart() {
	yield takeLatest(GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_RESET, resetCountryList);
}
/** *********************  END COUNTRY LIST  ******************** */

/** *********************  START STATE LIST  ******************** */
export function* getStateList({ payload }: any) {
	try {
		const jsonData = {
			CountryID: payload.countryID,
			isDoubleEncode: 0,
		};
		const stateData = encryptData(jsonData, 'CountryStateListGetKey');
		// @ts-ignore
		const responseData = yield call(getAllStateList, stateData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getStateListFailure(responseData.data));
		} else {
			yield put(getStateListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getStateListFailure(error));
	}
}

export function* resetStateList() {
	yield put(getStateListResponseChanged());
}

export function* onGetStateList() {
	yield takeLatest(GeneralActionTypes.GET_STATE_LIST_START, getStateList);
}

export function* onResetStateResponseStart() {
	yield takeLatest(GeneralActionTypes.GET_STATE_LIST_RESPONSE_RESET, resetStateList);
}
/** *********************  END STATE LIST  ******************** */

/** *********************  START CITY LIST  ******************** */
export function* getCityList({ payload }: any) {
	try {
		const jsonData = {
			StateID: payload.stateID,
			isDoubleEncode: 0,
		};
		const cityData = encryptData(jsonData, 'StateCityListGetKey');
		// @ts-ignore
		const responseData = yield call(getAllCityList, cityData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getCityListFailure(responseData.data));
		} else {
			yield put(getCityListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCityListFailure(error));
	}
}

export function* resetCityList() {
	yield put(getCityListResponseChanged());
}

export function* onGetCityList() {
	yield takeLatest(GeneralActionTypes.GET_CITY_LIST_START, getCityList);
}

export function* onResetCityResponseStart() {
	yield takeLatest(GeneralActionTypes.GET_CITY_LIST_RESPONSE_RESET, resetCityList);
}
/** *********************  END CITY LIST  ******************** */

/** *********************  START PIN LIST  ******************** */
export function* getPincodeList({ payload }: any) {
	try {
		// const cityData = encryptData(jsonData, 'StateCityListGetKey');
		// @ts-ignore
		const responseData = yield call(getAllPincodeList, payload);
		if (responseData.data.statusCode === '500') {
			yield put(getPinCodeListFailure(responseData.data[0]));
		} else {
			yield put(getPinCodeListSuccess(responseData.data[0]));
		}
	} catch (error) {
		yield put(getCityListFailure(error));
	}
}

export function* resetPincodeList() {
	yield put(getPinCodeListResponseChanged());
}

export function* onGetPincodeList() {
	yield takeLatest(GeneralActionTypes.GET_PINCODE_LIST_START, getPincodeList);
}

export function* onResetPincodeResponseStart() {
	yield takeLatest(GeneralActionTypes.GET_PINCODE_LIST_RESPONSE_RESET, resetPincodeList);
}
/** *********************  END PIN LIST  ******************** */

/** *********************  START DISTRICT LIST  ******************** */
export function* districtListGet({ payload }: any) {
	try {
		const jsonData = {
			StateID: payload.stateID,
		};
		const districtData = encryptData(jsonData, 'DistrictCityListGetKey');
		// @ts-ignore
		const responseData = yield call(getDistrictList, districtData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getDistrictListFailure(responseData.data));
		} else {
			yield put(getDistrictListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDistrictListFailure(error));
	}
}

export function* resetDistrictList() {
	yield put(getDistrictListResponseChanged());
}

export function* onGetDistrictList() {
	yield takeLatest(GeneralActionTypes.GET_DISTRICT_LIST_START, districtListGet);
}

export function* onResetDistrictResponseStart() {
	yield takeLatest(GeneralActionTypes.GET_DISTRICT_LIST_RESPONSE_RESET, resetDistrictList);
}
/** *********************  END DISTRICT LIST  ******************** */

/** *********************  START GET ALL INDUSTRY   ******************** */
export function* allIndustryListGet({ payload }: any) {
	try {
		const key = 'GetAllIndustryListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			Secratekey: key,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllIndustryList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllIndustryListFailure(responseData.data));
		} else {
			yield put(getAllIndustryListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllIndustryListFailure(error));
	}
}

export function* resetAllIndustryListReset() {
	yield put(getAllIndustryListResponseChanged());
}

export function* onGetIndustryListDetails() {
	yield takeLatest(GeneralActionTypes.GET_INDUSTRY_LIST_START, allIndustryListGet);
}

export function* onGetIndustryListResponseReset() {
	yield takeLatest(
		GeneralActionTypes.GET_INDUSTRY_LIST_RESPONSE_RESET_START,
		resetAllIndustryListReset,
	);
}
/** *********************  END GET ALL INDUSTRY ******************** */

/** *********************  START GET SUB INDUSTRY   ******************** */
export function* allSubIndustryListGet({ payload }: any) {
	try {
		const key = 'GetSubIndustryListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			IndustryID: payload.industryID,
			Secratekey: key,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getSubIndustryList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSubIndustryListFailure(responseData.data));
		} else {
			yield put(getSubIndustryListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSubIndustryListFailure(error));
	}
}

export function* resetSubIndustryListReset() {
	yield put(getSubIndustryListResponseChanged());
}

export function* onGetSubIndustryListDetails() {
	yield takeLatest(GeneralActionTypes.GET_SUB_INDUSTRY_LIST_START, allSubIndustryListGet);
}

export function* onGetSubIndustryListResponseReset() {
	yield takeLatest(
		GeneralActionTypes.GET_SUB_INDUSTRY_LIST_RESPONSE_RESET_START,
		resetSubIndustryListReset,
	);
}
/** *********************  END GET SUB INDUSTRY ******************** */

/** *********************  START FETCH ALL BRANCHES LIST  ******************** */
export function* fetchAllBranchesList({ payload }: any) {
	try {
		const key = 'FetchAllBranchKey';
		const { companyID, userID, userRole, userLevel, databaseName, userAccessBranchID, page } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
			Page: page,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allBranchesFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllBranchesFailure(responseData.data));
		} else {
			yield put(fetchAllBranchesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllBranchesFailure(error));
	}
}

export function* resetFetchAllBranchesListResponse() {
	yield put(fetchAllBranchesResponseChanged());
}

export function* onFetchAllBranchesListDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_BRANCHES_START, fetchAllBranchesList);
}

export function* onFetchAllBranchesResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_BRANCHES_RESPONSE_RESET_START,
		resetFetchAllBranchesListResponse,
	);
}
/** *********************  END FETCH ALL BRANCHES LIST ******************** */

/** *********************  START FETCH ALL PURPOSE OF LOAN TYPE LIST  ******************** */
export function* fetchAllPurposeofLoanList({ payload }: any) {
	try {
		const key = 'FetchAllPurposeOfLoansKey';
		const { companyID, userID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allPurposeOfLoanListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllPurposeOfLoanListFailure(responseData.data));
		} else {
			yield put(fetchAllPurposeOfLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllPurposeOfLoanListFailure(error));
	}
}

export function* resetFetchAllPurposeofLoanListResponse() {
	yield put(fetchAllPurposeOfLoanListResponseChanged());
}

export function* onFetchAllPurposeofLoanListDetails() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_START,
		fetchAllPurposeofLoanList,
	);
}

export function* onFetchAllPurposeofLoanResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET_START,
		resetFetchAllPurposeofLoanListResponse,
	);
}
/** *********************  END FETCH ALL PURPOSE OF LOAN TYPE LIST ******************** */

/** *********************  START FETCH ALL PURPOSE OF LOAN TYPE LIST  ******************** */
export function* fetchAllPurposeofLoanTypeList({ payload }: any) {
	try {
		const key = 'FetchAllPurposeOfLoanTypesKey';
		const { companyID, userID, userRole, userLevel, databaseName, userAccessBranchID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allPurposeOfLoanTypeFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllPurposeOfLoanTypeFailure(responseData.data));
		} else {
			yield put(fetchAllPurposeOfLoanTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllPurposeOfLoanTypeFailure(error));
	}
}

export function* resetFetchAllPurposeofLoanTypeListResponse() {
	yield put(fetchAllPurposeOfLoanTypeResponseChanged());
}

export function* onFetchAllPurposeofLoanTypeListDetails() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_START,
		fetchAllPurposeofLoanTypeList,
	);
}

export function* onFetchAllPurposeofLoanTypeResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET_START,
		resetFetchAllPurposeofLoanTypeListResponse,
	);
}
/** *********************  END FETCH ALL PURPOSE OF LOAN TYPE LIST ******************** */

/** *********************  START FETCH ALL BUSINESS LIST  ******************** */
export function* fetchAllBusinessList({ payload }: any) {
	try {
		const key = 'GetAllBusinessListKey';
		const { companyID, userID, userLevel, databaseName, userAccessBranchID, centerID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			Level: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
			CenterID: centerID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allBusinessDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllBusinessListFailure(responseData.data));
		} else {
			yield put(fetchAllBusinessListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllBusinessListFailure(error));
	}
}

export function* resetFetchAllBusinessListResponse() {
	yield put(fetchAllBusinessListResponseChanged());
}

export function* onFetchAllBusinessListDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_START, fetchAllBusinessList);
}

export function* onFetchAllBusinessResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_RESPONSE_RESET_START,
		resetFetchAllBusinessListResponse,
	);
}
/** *********************  END FETCH ALL BUSINESS LIST ******************** */

/** *********************  START FETCH ALL PRODUCT TYPE LIST  ******************** */
export function* fetchAllProductTypesList({ payload }: any) {
	try {
		const key = 'FetchAllProductTypesKey';
		const { companyID, databaseName } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allProductTypeFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllProductTypeFailure(responseData.data));
		} else {
			yield put(fetchAllProductTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllProductTypeFailure(error));
	}
}

export function* resetFetchAllProductTypesResponse() {
	yield put(fetchAllProductTypeResponseChanged());
}

export function* onFetchAllProductTypesDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_START, fetchAllProductTypesList);
}

export function* onFetchAllProductTypesResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_RESPONSE_RESET,
		resetFetchAllProductTypesResponse,
	);
}
/** *********************  END FETCH ALL PRODUCT TYPE LIST ******************** */

/** *********************  START FETCH ALL PRODUCTS LIST  ******************** */
export function* fetchAllProductsList({ payload }: any) {
	try {
		const key = 'FetchAllProductList';
		const { companyID, productTypeID, databaseName, payAsYouGo } = payload;
		const jsonData = {
			CompanyID: companyID,
			ProductType: productTypeID,
			DatabaseName: databaseName,
			PayAsYouGo: payAsYouGo,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allProductsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllProductListFailure(responseData.data));
		} else {
			yield put(fetchAllProductListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllProductListFailure(error));
	}
}

export function* resetFetchAllProductsResponse() {
	yield put(fetchAllProductListResponseChanged());
}

export function* onFetchAllProductsDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_PRODUCT_START, fetchAllProductsList);
}

export function* onFetchAllProductsResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_PRODUCT_RESPONSE_RESET,
		resetFetchAllProductsResponse,
	);
}
/** *********************  END FETCH ALL PRODUCTS LIST ******************** */

/** *********************  START FETCH STAFF BASED ON BRANCH LIST  ******************** */
export function* fetchAllBranchOfficerList({ payload }: any) {
	try {
		const key = 'GetAllBranchOfficerList';
		const { companyID, branchID, userLevel, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			AreaID: branchID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allBranchOfficerFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllBranchOfficerFailure(responseData.data));
		} else {
			yield put(fetchAllBranchOfficerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllBranchOfficerFailure(error));
	}
}

export function* resetFetchAllBranchOfficerResponse() {
	yield put(fetchAllBranchOfficerResponseChanged());
}

export function* onFetchAllBranchOfficerDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_START, fetchAllBranchOfficerList);
}

export function* onFetchAllBranchOfficerResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_RESPONSE_RESET_START,
		resetFetchAllBranchOfficerResponse,
	);
}
/** *********************  END STAFF BASED ON BRANCH LIST ******************** */

/** *********************  CENTER FETCH BASED ON BRANCH LIST  ******************** */

export function* fetchAllCenterList({ payload }: any) {
	try {
		const key = 'GetAllCentersList';
		const { companyID, branchID, userLevel, databaseName, memberID } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			Level: userLevel,
			DatabaseName: databaseName,
			MemberID: memberID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allCenterFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllCenterListFailure(responseData.data));
		} else {
			yield put(fetchAllCenterListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllCenterListFailure(error));
	}
}

export function* resetFetchAllCenterResponse() {
	yield put(fetchAllCenterListResponseChanged());
}

export function* onFetchAllCenterDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_CENTERS_START, fetchAllCenterList);
}

export function* onFetchAllCenterResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_CENTERS_RESPONSE_RESET_START,
		resetFetchAllCenterResponse,
	);
}
/** *********************  END CENTER FETCH BASED ON BRANCH LIST ******************** */

/** *********************  GROUP FETCH BASED ON CENTER LIST  ******************** */
export function* fetchCenterGroupList({ payload }: any) {
	try {
		const { centerID, databaseName, companyID } = payload;
		const key = 'FetchAllGroupListKey';
		const jsonData = {
			LocationID: centerID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGroupCenterFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCenterGroupListFailure(responseData.data));
		} else {
			yield put(fetchCenterGroupListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCenterGroupListFailure(error));
	}
}

export function* resetFetchCenterGroupResponse() {
	yield put(fetchCenterGroupListResponseChanged());
}

export function* onFetchCenterGroupDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_CENTER_GROUPS_START, fetchCenterGroupList);
}

export function* onFetchCenterGroupResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_CENTER_GROUPS_RESPONSE_RESET_START,
		resetFetchCenterGroupResponse,
	);
}
/** *********************  END GROUP FETCH BASED ON CENTER LIST ******************** */

/** *********************  MEMBER FETCH BASED ON GROUP LIST  ******************** */
export function* fetchGroupMemberList({ payload }: any) {
	try {
		const key = 'FetchGroupMembersListKey';
		const jsonData = {
			BranchID: payload.branchID,
			CenterID: payload.centerID,
			GroupID: payload.groupID,
			LoanIndexID: payload.loanIndexID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGroupMembersFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGroupMemberListFailure(responseData.data));
		} else {
			yield put(fetchGroupMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGroupMemberListFailure(error));
	}
}

export function* resetFetchGroupMemberResponse() {
	yield put(fetchGroupMemberListResponseChanged());
}

export function* onFetchGroupMemberDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_GROUP_MEMBERS_START, fetchGroupMemberList);
}

export function* onFetchGroupMemberResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_GROUP_MEMBERS_RESPONSE_RESET_START,
		resetFetchGroupMemberResponse,
	);
}
/** *********************  END GROUP FETCH BASED ON CENTER LIST ******************** */

/** *********************  START FETCH STAFF BASED ON BRANCH LIST  ******************** */

export function* fetchAllInvestorList({ payload }: any) {
	try {
		const key = 'GetAllInvestorListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			UserLevel: payload.userLevel,
			DatabaseName: payload.databaseName,
			UserID: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allInvestorFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllInverstorListFailure(responseData.data));
		} else {
			yield put(fetchAllInverstorListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllInverstorListFailure(error));
	}
}

export function* resetFetchAllInvestorResponse() {
	yield put(fetchAllInverstorListResponseChanged());
}

export function* onFetchAllInvestorDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_START, fetchAllInvestorList);
}

export function* onFetchAllInvestorResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_RESPONSE_RESET_START,
		resetFetchAllInvestorResponse,
	);
}
/** *********************  END STAFF BASED ON BRANCH LIST ******************** */

/** *********************  START FETCH All GROUP  ******************** */
export function* fetchAllGroupData({ payload }: any) {
	try {
		const key = 'GetAllGroupsListkey';
		const { databaseName, centerID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			LocationID: centerID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchallGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllGroupListFailure(responseData.data));
		} else {
			yield put(fetchAllGroupListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllGroupListFailure(error));
	}
}

export function* resetGroupResponse() {
	yield put(fetchAllGroupListResponseChanged());
}

export function* onFetchAllGroupDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_GROUP_LIST_START, fetchAllGroupData);
}

export function* onFetchAllGroupResponseReset() {
	yield takeLatest(GeneralActionTypes.FETCH_ALL_GROUP_LIST_RESPONSE_RESET, resetGroupResponse);
}

/** *********************  END FETCH All GROUP  ******************** */

/** *********************  START FETCH ALL BRANCHES LIST  ******************** */
export function* fetchBranchAccountList({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const jsonData = {
			CompanyID: payload.CompanyID,
			UserID: payload.UserID,
			ViewUser: payload.ViewUser,
			DatabaseName: payload.DatabaseName,
			UserAccessBranchID: payload.UserAccessBranchID,
			InfogID: payload.InfogID,
			Type: payload.Type,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(BranchAccountListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBranchAccountListFailure(responseData.data));
		} else {
			yield put(fetchBranchAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBranchAccountListFailure(error));
	}
}

export function* resetFetchBranchAccountListResponse() {
	yield put(fetchBranchAccountListResponseChanged());
}

export function* onFetchBranchAccountListDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_START, fetchBranchAccountList);
}

export function* onFetchBranchAccountListResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_RESET_START,
		resetFetchBranchAccountListResponse,
	);
}
/** *********************  END FETCH ALL BRANCHES LIST ******************** */

/** *********************  LOAN INDEX FETCH BASED ON GROUP LIST  ******************** */
export function* fetchGroupLoanIndexList({ payload }: any) {
	try {
		const key = 'FetchAllLoanIndexListKey';
		const jsonData = {
			BranchID: payload.branchID,
			LocationID: payload.centerID,
			GroupID: payload.groupID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			Type: payload.type,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGroupLoanIndexListAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGroupLoanIndexFailure(responseData.data));
		} else {
			yield put(fetchGroupLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGroupLoanIndexFailure(error));
	}
}

export function* resetFetchGroupLoanIndexResponse() {
	yield put(fetchGroupLoanIndexResponseChanged());
}

export function* onFetchGroupLoanIndexDetails() {
	yield takeLatest(
		GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_START,
		fetchGroupLoanIndexList,
	);
}

export function* onFetchGroupLoanIndexResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_RESET_START,
		resetFetchGroupLoanIndexResponse,
	);
}
/** *********************  END LOAN INDEX FETCH BASED ON GROUP LIST ******************** */

/** *********************  LOAN INDEX FETCH BY SEARCH LIST  ******************** */
export function* fetchSearchLoanIndexList({ payload }: any) {
	try {
		const key = 'SearchLoanIndexDetailsTokenKey';
		const jsonData = {
			BranchID: payload.branchID,
			CenterID: payload.centerID,
			GroupID: payload.groupID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UserID: payload.userID,
			UserRole: payload.userRole,
			Level: payload.userLevel,
			LoanIndexType: payload.loanIndexType,
			Limit: payload.limit || 0,
			SearchData: payload.searchInput || '',
			LoginUserRoleID: payload.userRoleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSearchLoanIndexListAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSearchLoanIndexFailure(responseData.data));
		} else {
			yield put(fetchSearchLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSearchLoanIndexFailure(error));
	}
}

export function* resetFetchSearchLoanIndexResponse() {
	yield put(fetchSearchLoanIndexResponseChanged());
}

export function* onFetchSearchLoanIndexDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_START, fetchSearchLoanIndexList);
}

export function* onFetchSearchLoanIndexResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_RESPONSE_RESET_START,
		resetFetchSearchLoanIndexResponse,
	);
}
/** *********************  END LOAN INDEX FETCH BY SEARCH LIST ******************** */

/** *********************  START FETCH VERSION LIST  ******************** */
export function* fetchVersionList({ payload }: any) {
	try {
		const key = 'GetVersionDataKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(VersionDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchVersionFailure(responseData.data));
		} else {
			yield put(fetchVersionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchVersionFailure(error));
	}
}

export function* resetFetchVersionResponse() {
	yield put(fetchVersionResponseChanged());
}

export function* onFetchVersionDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_VERSION_START, fetchVersionList);
}

export function* onFetchVersionResponseReset() {
	yield takeLatest(GeneralActionTypes.FETCH_VERSION_RESPONSE_RESET, resetFetchVersionResponse);
}
/** *********************  END FETCH VERSION LIST ******************** */

/** *********************  START UPDATE VERSION LIST  ******************** */
export function* updateVersionList({ payload }: any) {
	try {
		const key = 'UpdateVersionDataKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			IsBranch: payload.isBranch,
			IsCenter: payload.isCenter,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(VersionDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateVersionFailure(responseData.data));
		} else {
			yield put(updateVersionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateVersionFailure(error));
	}
}

export function* resetUpdateVersionResponse() {
	yield put(updateVersionResponseChanged());
}

export function* onUpdateVersionDetails() {
	yield takeLatest(GeneralActionTypes.UPDATE_VERSION_START, updateVersionList);
}

export function* onUpdateVersionResponseReset() {
	yield takeLatest(GeneralActionTypes.UPDATE_VERSION_RESPONSE_RESET, resetUpdateVersionResponse);
}
/** *********************  END UPDATE VERSION LIST ******************** */

/** *********************  START PINCODE DETAILS LIST  ******************** */
export function* fetchPincodeDetailsList({ payload }: any) {
	try {
		const key = 'FetchPincodeListKey';
		const { pincode, state } = payload;
		const jsonData = {
			Pincode: pincode,
			State: state,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PincodeDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPincodeDetailsFailure(responseData.data));
		} else {
			yield put(fetchPincodeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPincodeDetailsFailure(error));
	}
}

export function* resetFetchPincodeDetailsResponse() {
	yield put(fetchPincodeDetailsResponseChanged());
}

export function* onFetchPincodeDetails() {
	yield takeLatest(GeneralActionTypes.FETCH_PINCODE_DETAILS_START, fetchPincodeDetailsList);
}

export function* onFetchPincodeDetailsResponseReset() {
	yield takeLatest(
		GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_RESET,
		resetFetchPincodeDetailsResponse,
	);
}
/** *********************  END PINCODE DETAILS LIST ******************** */

/** *********************  START GENERIC PINCODE DETAILS LIST  ******************** */
export function* genericPincodeDetailsList({ payload }: any) {
	const { fieldType, pincode, state } = payload;
	try {
		const key = 'FetchPincodeListKey';
		const jsonData = {
			Pincode: pincode,
			State: state,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PincodeDetailsFetch, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(genericPincodeDetailsFailure(fieldType, responseData.data));
		} else {
			yield put(genericPincodeDetailsSuccess(fieldType, responseData.data));
		}
	} catch (error) {
		yield put(genericPincodeDetailsFailure(fieldType, error));
	}
}

export function* resetGenericPincodeDetailsResponse({ payload }: any) {
	yield put(genericPincodeDetailsResponseChanged(payload.fieldType));
}

export function* onGenericPincodeDetails() {
	yield takeLatest(GeneralActionTypes.GENERIC_PINCODE_DETAILS_START, genericPincodeDetailsList);
}

export function* onGenericPincodeDetailsResponseReset() {
	yield takeLatest(
		GeneralActionTypes.GENERIC_PINCODE_DETAILS_RESPONSE_RESET,
		resetGenericPincodeDetailsResponse,
	);
}
/** *********************  END GENERIC PINCODE DETAILS LIST ******************** */

/** *********************  Get Location List based on Level START  ******************** */
export function* getLocationBasedLevelList({ payload }: any) {
	try {
		const key = 'AllLocationBasedLevelKey';
		const jsonData = {
			CompanyID: payload.companyID,
			UserID: payload.userID,
			UserRole: payload.userRole,
			Level: payload.level,
			BranchID: payload.branchID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllLocationListBasedLevel, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLocationListBasedLevelFailure(responseData.data));
		} else {
			yield put(getLocationListBasedLevelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLocationListBasedLevelFailure(error));
	}
}

export function* resetGetLocationBasedLevelResponse() {
	yield put(getLocationListBasedLevelResponseChanged());
}

export function* onGetLocationListBasedLevelDetails() {
	yield takeLatest(
		GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_START,
		getLocationBasedLevelList,
	);
}

export function* onGetLocationListBasedLevelSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_RESET,
		resetGetLocationBasedLevelResponse,
	);
}
/** *********************  Get Location List based on Level END ******************** */

/** *********************  CHECK GOOGLE AUTHENTICATION START  ******************** */
export function* checkAuthenticationKey({ payload }: any) {
	try {
		const key = 'CheckUserAuthKey';
		const jsonData = {
			Secrate: payload.SecrateAuth,
			AuthCode: payload.AuthenticationCode,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkAuthenticationKeyAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkGoogleAuthenticationFailure(responseData.data));
		} else {
			yield put(checkGoogleAuthenticationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkGoogleAuthenticationFailure(error));
	}
}

export function* resetAuthenticationResponse() {
	yield put(checkGoogleAuthenticationResponseChanged());
}

export function* onCheckAuthenticationKeyStart() {
	yield takeLatest(GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_START, checkAuthenticationKey);
}

export function* onCheckAuthenticationKeyResponseReset() {
	yield takeLatest(
		GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_RESPONSE_RESET,
		resetAuthenticationResponse,
	);
}
/** *********************  CHECK GOOGLE AUTHENTICATION END ******************** */

/** *********************  PURPOSE OF LOAN PROPOSAL START  ******************** */
export function* getPurposeOfLoanProposalList({ payload }: any) {
	try {
		const key = 'getAllPurposeOfLoanListDetailsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			UserID: payload.userID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllPurposeOfLoanProposalList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPurposeOfLoanProposalListFailure(responseData.data));
		} else {
			yield put(getPurposeOfLoanProposalListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPurposeOfLoanProposalListFailure(error));
	}
}

export function* resetGetPurposeOfLoanProposalListResponse() {
	yield put(getPurposeOfLoanProposalListResponseChanged());
}

export function* onGetPurposeOfLoanProposalListDetails() {
	yield takeLatest(
		GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_START,
		getPurposeOfLoanProposalList,
	);
}

export function* onGetPurposeOfLoanProposalListSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
		resetGetPurposeOfLoanProposalListResponse,
	);
}
/** *********************  PURPOSE OF LOAN PROPOSAL END  ******************** */

/** *********************  OFFICER BASED ON LEVEL FOR PROPOSAL START  ******************** */
export function* getOfficerBesedOnLevelListProposal({ payload }: any) {
	try {
		const key = 'GetAllOfficerUserBasedOnLevelKey';
		const jsonData = {
			CompanyID: payload.companyID,
			locationID: payload.locationID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllOfficerBesedOnLevelListProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerBesedOnLevelListProposalFailure(responseData.data));
		} else {
			yield put(getOfficerBesedOnLevelListProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerBesedOnLevelListProposalFailure(error));
	}
}

export function* resetGetOfficerBesedOnLevelListProposalResponse() {
	yield put(getOfficerBesedOnLevelListProposalResponseChanged());
}

export function* onGetOfficerBesedOnLevelListProposalDetails() {
	yield takeLatest(
		GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_START,
		getOfficerBesedOnLevelListProposal,
	);
}

export function* onGetOfficerBesedOnLevelListProposalSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_RESET,
		resetGetOfficerBesedOnLevelListProposalResponse,
	);
}
/** *********************  OFFICER BASED ON LEVEL FOR PROPOSAL END  ******************** */

/** *********************  THRIFT LIST FOR PROPOSAL START  ******************** */
export function* getThriftListProposal({ payload }: any) {
	try {
		const key = 'getAllThriftListKey';
		const { companyID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllThriftListProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getThriftListProposalFailure(responseData.data));
		} else {
			yield put(getThriftListProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getThriftListProposalFailure(error));
	}
}

export function* resetGetThriftListProposalResponse() {
	yield put(getThriftListProposalResponseChanged());
}

export function* onGetThriftListProposalDetails() {
	yield takeLatest(GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_START, getThriftListProposal);
}

export function* onGetThriftListProposalSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_RESPONSE_RESET,
		resetGetThriftListProposalResponse,
	);
}
/** *********************  THRIFT LIST FOR PROPOSAL END  ******************** */

/** *********************  THRIFT DETAILS FOR PROPOSAL START  ******************** */
export function* getThriftDetails({ payload }: any) {
	try {
		const { thriftID, databaseName } = payload;
		const key = 'GetThriftDetailsTokenDataKey';
		const jsonData = {
			ThriftID: thriftID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllThriftDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getThriftDetailsFailure(responseData.data));
		} else {
			yield put(getThriftDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getThriftDetailsFailure(error));
	}
}

export function* resetGetThriftDetailsResponse() {
	yield put(getThriftDetailsResponseChanged());
}

export function* onGetThriftDetailsDetails() {
	yield takeLatest(GeneralActionTypes.GET_THRIFT_DETAILS_START, getThriftDetails);
}

export function* onGetThriftDetailsSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_THRIFT_DETAILS_RESPONSE_RESET,
		resetGetThriftDetailsResponse,
	);
}
/** *********************  THRIFT DETAILS FOR PROPOSAL END  ******************** */

/** *********************  THRIFT TWO DETAILS FOR PROPOSAL START  ******************** */
export function* getThriftTwoDetails({ payload }: any) {
	try {
		const { thriftID, databaseName } = payload;
		const key = 'GetThriftDetailsTokenDataKey';
		const jsonData = {
			ThriftID: thriftID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllThriftDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getThriftTwoDetailsFailure(responseData.data));
		} else {
			yield put(getThriftTwoDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getThriftTwoDetailsFailure(error));
	}
}

export function* resetGetThriftTwoDetailsResponse() {
	yield put(getThriftTwoDetailsResponseChanged());
}

export function* onGetThriftTwoDetailsDetails() {
	yield takeLatest(GeneralActionTypes.GET_THRIFT_TWO_DETAILS_START, getThriftTwoDetails);
}

export function* onGetThriftTwoDetailsSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_THRIFT_TWO_DETAILS_RESPONSE_RESET,
		resetGetThriftTwoDetailsResponse,
	);
}
/** *********************  THRIFT TWO DETAILS FOR PROPOSAL END  ******************** */

/** *********************  NON APPROVE MEMBER DETAILS START  ******************** */
export function* getNonApproveMembersDetails({ payload }: any) {
	try {
		const key = 'FetchAllNonApproveMembersKey';
		const { loanIndexID, databaseName, companyID } = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAllNonApproveMembersDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getNonApproveMembersDetailsFailure(responseData.data));
		} else {
			yield put(getNonApproveMembersDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getNonApproveMembersDetailsFailure(error));
	}
}

export function* resetGetNonApproveMembersDetailsResponse() {
	yield put(getNonApproveMembersDetailsResponseChanged());
}

export function* onGetNonApproveMembersDetailsDetails() {
	yield takeLatest(
		GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_START,
		getNonApproveMembersDetails,
	);
}

export function* onGetNonApproveMembersDetailsSuccessReset() {
	yield takeLatest(
		GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_RESET,
		resetGetNonApproveMembersDetailsResponse,
	);
}
/** *********************  NON APPROVE MEMBER DETAILS END  ******************** */

/** *********************  START TODAY GOLD PRICE LIST  ******************** */
export function* getTodayGoldPrice({ payload }: any) {
	try {
		const { databaseName, companyID } = payload;
		const key = 'GetTodayGoldPriceKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(todayGoldPriceGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getTodayGoldPriceFailure(responseData.data));
		} else {
			yield put(getTodayGoldPriceSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getTodayGoldPriceFailure(error));
	}
}

export function* resetTodayGoldPriceResponse() {
	yield put(getTodayGoldPriceResponseChanged());
}

export function* onGetTodayGoldPrice() {
	yield takeLatest(GeneralActionTypes.GET_TODAY_GOLD_PRICE_START, getTodayGoldPrice);
}

export function* onGetTodayGoldPriceResponseReset() {
	yield takeLatest(
		GeneralActionTypes.GET_TODAY_GOLD_PRICE_RESPONSE_RESET,
		resetTodayGoldPriceResponse,
	);
}

/** *********************  END TODAY GOLD PRICE LIST  ******************** */

/** *********************  START UPDATE TODAY GOLD PRICE LIST  ******************** */
export function* updateTodayGoldPrice({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			userID,
			userName,
			goldPrice24k,
			goldPrice22k,
			goldPrice20k,
			goldPrice18k,
			goldPrice16k,
		} = payload;
		const key = 'UpdateTodayGoldPriceKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			TodayGoldPrice: goldPrice24k,
			TodayGoldPrice22k: goldPrice22k,
			TodayGoldPrice20k: goldPrice20k,
			TodayGoldPrice18k: goldPrice18k,
			TodayGoldPrice16k: goldPrice16k,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(todayGoldPriceUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateTodayGoldPriceFailure(responseData.data));
		} else {
			yield put(updateTodayGoldPriceSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateTodayGoldPriceFailure(error));
	}
}

export function* resetUpdateTodayGoldPriceResponse() {
	yield put(updateTodayGoldPriceResponseChanged());
}

export function* onUpdateTodayGoldPrice() {
	yield takeLatest(GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_START, updateTodayGoldPrice);
}

export function* onUpdateTodayGoldPriceResponseReset() {
	yield takeLatest(
		GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_RESPONSE_RESET,
		resetUpdateTodayGoldPriceResponse,
	);
}

/** *********************  END UPDATE TODAY GOLD PRICE LIST  ******************** */

/******************GET PROFIT AND LOSS *********************/
export function* GetBranchesFromState({ payload }: any) {
	try {
		const key = 'FetchLoadAdminAreaList';
		const jsonData = {
			CompanyID: payload.CompanyID,
			UserID: payload.UserID,
			UserRole: payload.UserRole,
			Level: payload.Level,
			DatabaseName: payload.DatabaseName,
			BranchID: payload.branchID,
			StateID: payload.StateID,
			StateName: payload.StateName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(StatewiseBranchDetails, encodeData); // data received
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(GetStatewiseBranchesFailure(responseData.data));
		} else {
			yield put(GetStatewiseBranchesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(GetStatewiseBranchesFailure(error));
	}
}
export function* resetBranchesFromStateResponse() {
	yield put(GetStatewiseBranchesResponceChanged());
}

export function* onBranchesFromStateDetails() {
	yield takeLatest(GeneralActionTypes.GET_STATEWISW_BRANCHES_START, GetBranchesFromState);
}

export function* onBranchesFromStateResponseReset() {
	yield takeLatest(
		GeneralActionTypes.GET_STATEWISW_BRANCHES_RESPONSE_RESET,
		resetBranchesFromStateResponse,
	);
}
/******************GET PROFIT AND LOSS *********************/

export function* generalSaga() {
	yield all([
		call(onGetCountryList),
		call(onResetCountryResponseStart),
		call(onGetStateList),
		call(onResetStateResponseStart),
		call(onGetCityList),
		call(onResetCityResponseStart),
		call(onGetPincodeList),
		call(onResetPincodeResponseStart),
		call(onGetDistrictList),
		call(onResetDistrictResponseStart),
		call(onGetIndustryListDetails),
		call(onGetIndustryListResponseReset),
		call(onGetSubIndustryListDetails),
		call(onGetSubIndustryListResponseReset),
		call(onFetchAllBranchesListDetails),
		call(onFetchAllBranchesResponseReset),
		call(onFetchAllPurposeofLoanListDetails),
		call(onFetchAllPurposeofLoanResponseReset),
		call(onFetchAllPurposeofLoanTypeListDetails),
		call(onFetchAllPurposeofLoanTypeResponseReset),
		call(onFetchAllBusinessListDetails),
		call(onFetchAllBusinessResponseReset),
		call(onFetchAllProductTypesDetails),
		call(onFetchAllProductTypesResponseReset),
		call(onFetchAllProductsDetails),
		call(onFetchAllProductsResponseReset),
		call(onFetchAllBranchOfficerDetails),
		call(onFetchAllBranchOfficerResponseReset),
		call(onFetchAllCenterDetails),
		call(onFetchAllCenterResponseReset),
		call(onFetchAllInvestorDetails),
		call(onFetchAllInvestorResponseReset),
		call(onFetchAllGroupResponseReset),
		call(onFetchAllGroupDetails),
		call(onFetchCenterGroupDetails),
		call(onFetchCenterGroupResponseReset),
		call(onFetchGroupMemberDetails),
		call(onFetchGroupMemberResponseReset),
		call(onFetchBranchAccountListDetails),
		call(onFetchBranchAccountListResponseReset),
		call(onFetchGroupLoanIndexDetails),
		call(onFetchGroupLoanIndexResponseReset),
		call(onFetchSearchLoanIndexDetails),
		call(onFetchSearchLoanIndexResponseReset),
		call(onFetchVersionDetails),
		call(onFetchVersionResponseReset),
		call(onUpdateVersionDetails),
		call(onUpdateVersionResponseReset),
		call(onFetchPincodeDetails),
		call(onFetchPincodeDetailsResponseReset),
		call(onGetLocationListBasedLevelDetails),
		call(onGetLocationListBasedLevelSuccessReset),
		call(onGetPurposeOfLoanProposalListDetails),
		call(onGetPurposeOfLoanProposalListSuccessReset),
		call(onCheckAuthenticationKeyStart),
		call(onCheckAuthenticationKeyResponseReset),
		call(onGetOfficerBesedOnLevelListProposalDetails),
		call(onGetOfficerBesedOnLevelListProposalSuccessReset),
		call(onGetThriftListProposalDetails),
		call(onGetThriftListProposalSuccessReset),
		call(onGetThriftDetailsDetails),
		call(onGetThriftDetailsSuccessReset),
		call(onGetThriftTwoDetailsSuccessReset),
		call(onGetThriftTwoDetailsDetails),
		call(onGetNonApproveMembersDetailsDetails),
		call(onGetNonApproveMembersDetailsSuccessReset),
		call(onGetTodayGoldPrice),
		call(onGetTodayGoldPriceResponseReset),
		call(onUpdateTodayGoldPrice),
		call(onUpdateTodayGoldPriceResponseReset),
		call(onBranchesFromStateResponseReset),
		call(onBranchesFromStateDetails),
		call(onGenericPincodeDetails),
		call(onGenericPincodeDetailsResponseReset),
	]);
}
